import { Error } from "@mui/icons-material";
import { Stack, Typography, styled } from "@mui/material";
import { Link } from "react-router-dom";

const ErrorText = styled(Typography)({
  color: "var(--Error-Red-500, var(--Error, #EF4444))",
  fontFamily: "Söhne",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: "400",
});

export const ErrorComponent = ({ text }: { text: string }) => {
  const BasicError = () => {
    return (
      <Stack direction="row" gap={0.5} pt={1}>
        <Error sx={{ fontSize: "16px", color: "#EF4444" }} />
        <ErrorText>{text}</ErrorText>
      </Stack>
    );
  };
  const WalletsRedirect = () => {
    return (
      <Stack direction="row" gap={0.5} pt={1}>
        <Error sx={{ fontSize: "16px", color: "#EF4444" }} />
        <ErrorText>
          {text} Click <Link to={"/wallets/details"}>{` here`}</Link> to deposit
        </ErrorText>
      </Stack>
    );
  };
  return <>{text.includes("funds") ? <WalletsRedirect /> : <BasicError />}</>;
};
